import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { codingbarApi } from 'codingbar-api';

import i18n from 'lang/i18n';

import {
	initAction,
	openPlayGround,
	closePlayGround,
	setOnline,
	setOffline,
	addToast,
	clearCurrentSubmitting,
	setAIAUser,
	setAiMateSubscriptionPlans,
	setAiMateUserPlan,
	// ---- FOR BETA ----
	setUnitPermissions,
} from 'redux/reducers/app';

import { fetchAllCoursesIncludesStudent } from 'shared/api/Courses';
import { getUnitPermissions } from 'shared/api/Units';
import { fetchAImateSubscriptionPlans, getAImateUserCurrentSubscriptionPlan } from 'shared/api/aiMate';
import { getAIAUser, getAIAUserUidCache } from 'shared/api/AIARegistration';

import { ActionModal } from 'components';
import ToastQueue from 'components/common/Toast/ToastQueue';
import MultiLoginAlert from 'components/MultiLoginAlert/MultiLoginAlert';
import StudentTestAlert from 'components/StudentTestAlert/StudentTestAlert';

import Header from './Header/Header';
import InProgress from './InProgress';
import PlaygroundFrame from '../Playground/PlaygroundFrame';
import { isElectron, removeConfirmCloseListener } from '../../shared/util/utils';
import ErrorHandler from './ErrorHandler';
import CodingbarThemeProvider from '../../CodingbarThemeProvider';
import BodyContent from './BodyContent/BodyContent';
import ZoomManager from '../zoom/ZoomManager';

import './App.scss';

const mapStateToProps = (state) => {
	const app = state.app;
	return {
		initSuc: app.get('initSuc'),
		user: app.get('user'),
		multiLoginAlertShow: app.get('multiLoginAlertShow'),
	};
};
const mapDispatchToProps = {
	initAction,
};

@connect((state) => {
	const app = state.app.toJS();

	return {
		showPlayGround: app.showPlayGround,
		onlineStatus: app.onlineStatus,
		AImateSubscriptionPlans: app.AImateSubscriptionPlans,
	};
})
class App extends React.Component {
	static propTypes = {
		initSuc: PropTypes.bool.isRequired,
		initAction: PropTypes.func.isRequired,
		user: PropTypes.object,
	};

	constructor(props) {
		super(props);

		this.state = {
			showZoom: false,
			selfKernel: undefined,
			progressDisabled: this.isProgressDisabled(props),
			headerDisabled: this.isHeaderDisabled(props),
			isShowToastAtBottom: this.isShowToastAtBottom(props),
			showVersionUpgrade: false,
			playgroundFullScreen: false,
			videoConferenceInfos: undefined,
			showTestModal: false,
			testRoute: undefined,
			testAlertData: undefined,
		};
		localStorage.removeItem('alreadyShowVersionUpgrade');
		this.onError = this.onError.bind(this);

		window.onerror = this.onWindowError;
	}

	isProgressDisabled(props) {
		const path = props.location && props.location.pathname ? props.location.pathname : undefined;
		if (!path) {
			return false;
		}

		if (path.indexOf('/desktop/') !== -1) {
			return true;
		}

		return false;
	}

	isHeaderDisabled = (props) => {
		//記得去改上面的 componentDidUpdate 復原 Header！
		const path = props.location && props.location.pathname ? props.location.pathname : undefined;
		if (!path) return false;
		if (path.indexOf('/desktop/') !== -1) return true;
		if (path.indexOf('/codingbar-client-document') !== -1) return true;
		if (path === '/login') return true;
		if (path === '/login' || path === '/login/' || path.includes('/login')) return true;
		return false;
	};

	isShowToastAtBottom = (props) => {
		const currentUrl = props.location && props.location.pathname ? props.location.pathname : undefined;

		if (!currentUrl) return false;

		const studentExerciseUrl = ['/student', '/course', '/lesson', '/exercise'];
		const studentTestUrl = ['/student', '/course', '/test', '/exercise'];

		return (
			studentExerciseUrl.every((el) => currentUrl.includes(el)) || studentTestUrl.every((el) => currentUrl.includes(el))
		);
	};

	onError(error, scriptURI, lineNumber, columnNumber, info) {
		const bug = {
			error: error,
			info: {
				scriptURI,
				lineNumber,
				columnNumber,
				info,
			},
		};

		console.error('onError#', bug);

		this.setState({
			bug: bug,
			showError: true,
		});
		return true;
	}

	onWindowError(error, scriptURI, lineNumber, columnNumber, info) {
		const bug = {
			error: error,
			info: {
				scriptURI,
				lineNumber,
				columnNumber,
				info,
			},
		};

		console.error('onWindowError#error:', error);
		console.error('onWindowError#info:', info);
	}

	componentDidMount = () => {
		const { dispatch } = this.props;
		this.props.initAction();

		fetchAImateSubscriptionPlans().then((res) => {
			const plans = res.result.sort((a, b) => {
				return a.monthlyPrice - b.monthlyPrice;
			});
			dispatch(setAiMateSubscriptionPlans(plans));
		});

		if (!window.location.href.includes('localhost:8080')) {
			if (window.navigator.onLine) {
				//change default to be true if online
				this.toggleOnlineStatus();
			}

			window.addEventListener('offline', this.toggleOnlineStatus);
			window.addEventListener('online', this.toggleOnlineStatus);
		} else {
			dispatch(setOnline());
		}
	};

	componentWillReceiveProps(nextProps) {
		try {
			this.checkDesktopVersion(nextProps);
			this.setupSpeedListener(nextProps);
			// this.setupNotificationService(nextProps);
		} catch (err) {
			console.error(err);
		}
	}

	componentDidUpdate = (prevProps) => {
		const path = this.props.location && this.props.location.pathname ? this.props.location.pathname : '';
		const prevPath = prevProps.location.pathname || '';
		const pathsToCheck = ['desktop', 'login'];
		const shouldCheckHeader = pathsToCheck.some((el) => {
			return path.includes(el) || prevPath.includes(el);
		});

		if (prevProps.location.pathname !== path && shouldCheckHeader) {
			this.setState({
				headerDisabled: this.isHeaderDisabled(this.props),
			});
		}
		if (prevProps.location.pathname !== path) {
			this.setState({
				isShowToastAtBottom: this.isShowToastAtBottom(this.props),
			});
		}

		// 切換帳號 aia user
		if (
			this.props.user &&
			this.props.user !== prevProps.user &&
			!prevProps.user &&
			getAIAUserUidCache() &&
			!this.props.aiaUser
		) {
			getAIAUser(getAIAUserUidCache()).then((res) => {
				this.props.dispatch(setAIAUser(res));
			});
		}

		// ---- FOR UNIT PERMISSION----
		if (this.props.user && this.props.user !== prevProps.user && !prevProps.user) {
			getUnitPermissions(this.props.user.get('unit')).then((res) => {
				this.props.dispatch(setUnitPermissions(res));
			});
		}

		if (
			this.props.user &&
			this.props.user !== prevProps.user &&
			!prevProps.user &&
			this.props.AImateSubscriptionPlans
		) {
			const uid = this.props.user.get('uid');
			getAImateUserCurrentSubscriptionPlan(uid, this.props.AImateSubscriptionPlans).then((res) => {
				// console.log('SSS>>>>variabgetAImateUserCurrentSubscriptionPlan:', res);
				this.props.dispatch(setAiMateUserPlan(res));
			});
		}
	};

	componentWillUnmount = () => {
		if (!window.location.href.includes('localhost:8080')) {
			window.removeEventListener('offline', this.toggleOnlineStatus);
			window.removeEventListener('online', this.toggleOnlineStatus);
		}
	};

	setupSpeedListener(nextProps) {
		const { dispatch } = this.props;
		const { initSuc } = nextProps;

		if (!initSuc || initSuc === this.props.initSuc) {
			return;
		}

		codingbarApi.getCoreService().setSpeedListener({
			usageUploadInterval: 60000, // every minute
			threshold: 10000, // if postJson takes more than 10 sec
			onSlowQuery: (info) => {
				console.log('onSlowQuery', info);
				dispatch(
					addToast({
						toastType: 'alert',
						toastText: i18n.t('common.slowQuery'),
						isShowAtBottom: this.state.isShowToastAtBottom,
					})
				);
			},
		});
	}

	setupNotificationService = () => {
		const user = this.getUser();
		const host = this;

		//學生偵測老師發起考試事件
		codingbarApi.getNotificationService().subscribeEventNotify('all', 'startTest', {
			onChanged(data) {
				if (data[0] && host.checkBetweenTime(data[0].sendTime)) {
					//只有第一次收到才需要處理資料
					if (user.role === data[0].role) {
						fetchAllCoursesIncludesStudent([user.uid]).then((courses) => {
							const findCourse = courses.filter((course) => course.id === data[0].testCourseId);

							if (findCourse.length !== 0) {
								host.setState({
									showTestModal: true,
									testRoute: data[0].testRoute,
									testAlertData: {
										modalTitle: i18n.t('component.StartTestAlertModal.title'),
										modalContent: i18n.t('component.StartTestAlertModal.content'),
										modalButtonWord: i18n.t('testPreview.gototest'),
									},
								});
							}
						});
					}
				}
			},
		});

		//學生偵測老師終止考試事件
		codingbarApi.getNotificationService().subscribeEventNotify('all', 'endTest', {
			onChanged(data) {
				if (data[0] && host.checkBetweenTime(data[0].sendTime)) {
					//只有第一次收到才需要處理資料
					if (user.role === data[0].role) {
						fetchAllCoursesIncludesStudent([user.uid]).then((courses) => {
							const findCourse = courses.filter((course) => course.id === data[0].testCourseId);

							if (findCourse.length !== 0) {
								const isTesting = window.location.href.includes('test') && window.location.href.includes('exercise');

								if (!isTesting) {
									this.props.dispatch(
										addToast({
											toastType: 'success',
											toastText: i18n.t('component.studentNotification.endTest'),
											actionText: i18n.t('loadingProcessBar.endExamDone.ok'),
											onClickAction: () => {
												this.goToViewTestScore(data[0].testCourseId);
											},
										})
									);
								} else {
									removeConfirmCloseListener();
									host.setState({
										showTestModal: true,
										testRoute: data[0].testRoute,
										testAlertData: {
											modalTitle: i18n.t('component.EndTestAlertModal.title'),
											modalContent: i18n.t('component.EndTestAlertModal.content'),
											modalButtonWord: i18n.t('common.leave'),
										},
									});
								}
							}
						});
					}
				}
			},
		});
	};

	checkBetweenTime = (timestamp) => {
		if (timestamp - 5000 <= Date.now() && Date.now() <= timestamp + 5000) {
			//差距 5s 以上視為網路環境不好, 應跳 網速過慢 toast
			return true;
		}
		return false;
	};
	goToViewTestScore = (testId) => {
		window.location.href = `/student/course/${testId}/test/beta`;
	};
	closeTestModal = () => {
		this.setState({
			showTestModal: false,
		});
	};

	componentDidCatch(error, info) {
		this.onError('global error', '', '', '', error);
	}

	togglePlayground = () => {
		const { dispatch } = this.props;

		if (this.props.showPlayGround === true) {
			dispatch(closePlayGround());
			dispatch(clearCurrentSubmitting());
		} else {
			dispatch(openPlayGround());
		}
	};

	setZoomVisible(visible, videoConferenceInfos) {
		// console.log("setZoomVisible#videoConferenceInfos", videoConferenceInfos);
		this.setState({
			showZoom: visible,
			videoConferenceInfos,
		});
	}

	toggleZoom = (videoConferenceInfos, isClicked) => {
		// console.log("toggleZoom#videoConferenceInfos", videoConferenceInfos);
		this.setZoomVisible(isClicked ? !this.state.showZoom : this.state.showZoom, videoConferenceInfos);
	};

	toggleOnlineStatus = () => {
		const { dispatch } = this.props;

		if (this.props.onlineStatus === true) {
			sessionStorage.removeItem('isReload');
			dispatch(setOffline());
		} else {
			dispatch(setOnline());
			const isReload = sessionStorage.getItem('isReload');
			if (!isReload) {
				sessionStorage.setItem('isReload', true);
				window.location.reload(true);
			}
		}
	};

	getUser() {
		try {
			return codingbarApi.getAuthService().getUser();
		} catch (err) {
			console.log(err);
		}
		return undefined;
	}

	checkDesktopVersion(props) {
		if (!isElectron()) {
			return;
		}

		if (localStorage.getItem('alreadyShowVersionUpgrade') === 'true') {
			return;
		}
	}

	checkDesktop() {
		const user = this.getUser();

		if (!user || !user.uid) {
			this.setState({
				selfKernel: undefined,
			});
		}

		if (!isElectron()) {
			console.log('App# not electron!');
			return;
		}

		if (this._timerInstance) {
			clearInterval(this._timerInstance);
			this._timerInstance = undefined;
		}

		this._timerInstance = setInterval(() => {
			// console.log("App# checkDesktop()")
			const user = this.getUser();
			if (user && user.uid) {
				codingbarApi
					.getCourseService()
					.getAvailableKernels()
					.then((kernels) => {
						const selfKernel = kernels.find((k) => k.name === user.uid);
						if (selfKernel) {
							this.setState({
								selfKernel: selfKernel,
							});
						} else {
							this.setState({
								selfKernel: undefined,
							});
						}
					});
			} else {
				this.setState({
					selfKernel: undefined,
				});
			}
		}, 10000);
	}

	handleFullScreen = (e) => {
		this.setState({ playgroundFullScreen: !this.state.playgroundFullScreen }, () => {
			console.log('fullscreen');
		});
	};

	getCloudPage() {
		const { initSuc, showPlayGround } = this.props;
		const { showZoom, videoConferenceInfos } = this.state;
		const user = JSON.parse(localStorage.getItem('user'));

		return (
			<div>
				{initSuc && user && showPlayGround && <PlaygroundFrame hidePlayground={this.togglePlayground} />}
				{initSuc || this.state.progressDisabled ? this.props.children : <InProgress />}
				{initSuc && user && showZoom && (
					<ZoomManager
						setVisible={this.setZoomVisible.bind(this)}
						videoConferenceInfos={videoConferenceInfos}
						visible={showZoom}
					/>
				)}
			</div>
		);
	}

	getDesktopPage() {
		return (
			<div style={{ fontSize: '36pt', textAlign: 'center', marginTop: '100px' }}>
				正在執行中
				<div style={{ fontSize: '18pt', marginTop: '100px' }}>
					請打開瀏覽器，輸入 <a href='https://app.codingbar.ai'>https://app.codingbar.ai</a> 開始快樂 Coding 吧!
				</div>
			</div>
		);
	}

	closeVersionCheckBox = () => {
		localStorage.setItem('alreadyShowVersionUpgrade', 'true');
		this.setState({
			showVersionUpgrade: false,
		});
	};

	renderVersionBox() {
		const confirmMessage = (
			<div>
				<div>您使用版本({this.state.desktopVersion})太舊，目前最新的版本是 v1.6</div>
				<div>請下載最新的 PC 版 CodingBar，得到最好的支援!</div>
				下載網址:{' '}
				<a href={'https://app.codingbar.ai/desktop/select/1.6/mac/pm'} target={'_blank'}>
					https://app.codingbar.ai/desktop/select/1.6/mac/pm
				</a>
			</div>
		);
		return (
			<ActionModal
				type='confirmation'
				isOpen={this.state.showVersionUpgrade}
				onConfirm={this.closeVersionCheckBox}
				modalTitle='版本更新'
				isShowClose={false}
				isHideCancelBtn
				modalBody={confirmMessage}
				confirmButtonText='繼續'
			/>
		);
	}

	closeErrorHandler() {
		this.setState({
			bug: undefined,
			showError: false,
		});

		this.props.history.push(`/`);
	}

	renderErrorHandler() {
		if (!this.state.showError || !this.state.bug) {
			return;
		}

		return (
			<div>
				<ErrorHandler bug={this.state.bug} close={this.closeErrorHandler.bind(this)} />
			</div>
		);
	}

	render() {
		return (
			<CodingbarThemeProvider>
				<link href='https://fonts.googleapis.com/css?family=Roboto+Condensed' rel='stylesheet'></link>

				{this.props.multiLoginAlertShow && <MultiLoginAlert />}

				{this.state.showTestModal && (
					<StudentTestAlert
						showTestModal={this.state.showTestModal}
						closeTestModal={this.closeTestModal}
						testRoute={this.state.testRoute}
						testAlertData={this.state.testAlertData}
						history={this.props.history}
					/>
				)}

				{!this.state.headerDisabled && (
					<Header
						headerLabel='CodingBar'
						togglePlayground={this.togglePlayground}
						toggleZoom={this.toggleZoom.bind(this)}
						headerDisabled={this.state.headerDisabled}
					/>
				)}

				{!this.state.showError ? this.getCloudPage() : ''}

				<BodyContent
					initSuc={this.props.initSuc}
					loggedIn={this.props.user ? true : false}
					userRole={this.props.user ? this.props.user.get('role') : undefined}
					showError={this.state.showError}
					bug={this.state.bug}
					desktopVersion={this.state.desktopVersion}
					showVersionUpgrade={this.state.showVersionUpgrade}
					closeErrorHandler={this.closeErrorHandler.bind(this)}
					closeVersionCheckBox={this.closeVersionCheckBox}
					onlineStatus={this.props.onlineStatus}
				/>
				<ToastQueue />
			</CodingbarThemeProvider>
		);
	}
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(App);
